import { css } from 'styled-components';

/* eslint-disable */
export const Fonts = css`
  @font-face {
    font-family: 'PF DinDisplay Pro Regular';
    src:
      url('https://s1.vcdn.biz/static/52642951/PFDinDisplayPro-Regular.woff2') format('woff2'),
      url('https://s9.vcdn.biz/static/52642911/PFDinDisplayPro-Regular.woff') format('woff');
    font-style: normal;
    font-weight: normal;
  }
  
  @font-face {
    font-family: 'PF DinDisplay Pro Medium';
    src:
      url('https://s1.vcdn.biz/static/f/1040655321/PFDinDisplayPro-Medium-29f6e368.woff2') format('woff2'),
      url('https://s1.vcdn.biz/static/f/1040655351/PFDinDisplayPro-Medium-347b3ccc.woff') format('woff');
    font-style: normal;
    font-weight: 500;
  }
  
  @font-face {
    font-family: 'PF DinDisplay Pro Bold';
    src:
      url('https://s1.vcdn.biz/static/f/1040655281/PFDinDisplayPro-Bold-1ec5ca61.woff2') format('woff2'),
      url('https://s1.vcdn.biz/static/f/1040655301/PFDinDisplayPro-Bold-de01fa2c.woff') format('woff');
    font-style: normal;
    font-weight: bold;
  }
`;
